import {Avatar, Backdrop, CircularProgress, Grid, ListItemAvatar, Paper, TextField} from "@mui/material";
import {Fragment, useEffect, useRef, useState} from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import {COLORS} from "../../Constants/Const";
import ListItemText from "@mui/material/ListItemText";

export function ChatComponent(){

    const [ statusLoad, setStatusLoad ] = useState(false);

    const refListScroll = useRef(null)

    const [historyChat, setHistoryChat ] = useState([]);

    const [textChat, setTextChat] = useState('');

    useEffect(() => {

        console.log(historyChat)
        refListScroll.current.scrollTop = refListScroll.current.scrollHeight;
        if(historyChat.length > 0 && historyChat[historyChat.length - 1].user === "mecanico"){
            const timeoutId = setTimeout(() => {

                // if(textChat.length > 0 && textChat[textChat.length - 1].user === "mecanico"){
                //     refListScroll.current.scrollTop = refListScroll.current.scrollHeight;
                // }
                setHistoryChat(old =>{

                    return[
                        ...old,
                        {user: "IA Busmen", text: "Pronto te daré respuestas a tus preguntas o soluciones a tus problemas"}
                    ]
                })
                setStatusLoad(oldStatus=>!oldStatus);
            }, 2000);
            return () => clearTimeout(timeoutId);
        }

    }, [historyChat]);

    const handlingQuestionChat = (event) =>{
        if (event.key === 'Enter') {
            setStatusLoad(oldStatus=>!oldStatus);
            setTextChat('');
            setHistoryChat([
                ...historyChat,
                {user: "mecanico", text: textChat},
            ]);
        }
    }

    const handleChange = (event) => {
        setTextChat(event.target.value);

    };


    return(
        <Grid item xs={12} style={{height: "58vh"}} >


            {
                statusLoad &&
                <Backdrop open={statusLoad} onClick={null}>
                    <CircularProgress/>
                </Backdrop>
            }
            <Paper elevation={12} style={{height: "58vh", overflow: "hidden"}}>
                <List ref={refListScroll} sx={{ width: '100%', bgcolor: 'background.paper', maxWidth: '100%' , overflowY: 'auto', maxHeight: '100%'}}>
                    {
                        historyChat.map((chat, index)=>(
                            <ListItem key={`chat-${index}`}>
                                <ListItemAvatar>
                                    <Avatar sx={{ bgcolor: COLORS.blue }}>M</Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={chat.user}
                                    secondary={
                                        <Fragment>
                                            {chat.text}
                                        </Fragment>
                                    }
                                />
                            </ListItem>
                        ))
                    }
                </List>
            </Paper>
            <TextField
                fullWidth
                disabled={statusLoad}
                value={textChat}
                variant="standard"
                onChange={handleChange}
                onKeyPress={handlingQuestionChat}
                label="Como te puedo ayudar..."
            />
        </Grid>
    )
}